module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n        ")], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$route.name) + " ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.activeUserPreference) ? _c('label', [_c('b', [_vm._v(" Created User Filter")])]) : _vm._e(), _vm._v(" "), (_vm.activeUserPreference) ? _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "pressed": _vm.activeButtonBranch,
      "variant": _vm.activeButtonBranch ? 'success' : 'danger'
    },
    on: {
      "click": function($event) {
        _vm.BranchBtnFilter(_vm.activeButtonBranch)
      }
    },
    model: {
      value: (_vm.activeButtonBranch),
      callback: function($$v) {
        _vm.activeButtonBranch = $$v
      },
      expression: "activeButtonBranch"
    }
  }, [_vm._v("Branch\n            " + _vm._s(_vm.activeButtonBranch ? " Filter On" : " Filter Off"))]), _vm._v(" "), (_vm.$sessionsStorage.get('userId')) ? _c('userBasedClient', {
    attrs: {
      "PMC_title": 'User Summary - ' + _vm.$sessionsStorage.get('employeeName'),
      "PMC_USERID": _vm.Filter.userFilter,
      "PMC_USERNAME": _vm.$sessionsStorage.get('nameUser'),
      "PMC_USERDESIG": _vm.$sessionsStorage.get('designation'),
      "PMC_BranchClientPre": _vm.$sessionsStorage.get('branchclientPre'),
      "PMC_TransportTypePre": _vm.$sessionsStorage.get('transportTypePre'),
      "PMC_UserEmpName": _vm.$sessionsStorage.get('employeeName'),
      "PMC_UserEmpCode": _vm.$sessionsStorage.get('employeeCode')
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.JOBList.length) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [(_vm.JOBList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.closeAssignmentPendencyList
    }
  }, [_vm._v("Close Assignment Pendency")]), _vm._v(" "), _c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.JOBList.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.JOBList,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "Branch",
      fn: function(row1) {
        return [(row1.item && row1.item.NotificationAlert2 && row1.item.NotificationAlert2.length > 0) ? _c('div', _vm._l((row1.item.NotificationAlert2), function(item, index2) {
          return _c('div', {
            key: index2,
            staticClass: "status-alerts"
          }, [_c('span', {
            class: {
              'alert alert-danger-text blink2': true
            }
          }, [_c('strong', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.message) ? [_vm._v("\n                    - "), _c('strong', [_vm._v(_vm._s(item.message)), _c('br'), _vm._v(_vm._s(item.conclusion))])] : _vm._e()], 2), _vm._v(" "), _c('br')])
        })) : _c('div'), _vm._v(" "), _c('tr', {
          class: {
            blink: _vm.isBlinking(row1.item)
          }
        }, [_c('td', [_c('div', {
          class: {
            'blink-circle': _vm.shouldBlink(row1.item)
          }
        })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row1.item.Branch))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Prealert : " + row1.item.is_prealertSend))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Manifest : " + row1.item.is_manifestation_status))]), _c('br'), _vm._v(" "), (row1.item.JOBTYPE.includes('FF')) ? _c('span', [_vm._v(_vm._s("FF : " + row1.item.FFInvStatus)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.JOBTYPE.includes('CC')) ? _c('span', [_vm._v(_vm._s("CC : " + row1.item.CCInvStatus)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.JOBTYPE.includes('TPT')) ? _c('span', [_vm._v(_vm._s("TPT : " + row1.item.TPTInvStatus)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.noteSeries) ? _c('span', [_vm._v(_vm._s("Note Series : " + row1.item.noteSeries)), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Billing : ")]), _vm._v(" "), (row1.item.TallyBillingSeries) ? _c('div', {
          staticClass: "text-left"
        }, [(row1.item.TallyBillingSeries) ? _c('div', _vm._l((row1.item.TallyBillingSeries.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1), _vm._v(" "), _c('BookingTrack', {
          attrs: {
            "containerArr": row1.item.freightContainers,
            "slineName": row1.item.shippingLine,
            "clientName": row1.item.clientName,
            "modal_title": ("Container Movement Booking No: " + (row1.item.BookingNo) + " Job No - " + (row1.item.JOBNO) + " Client: " + (row1.item.clientName)),
            "JOBNO": row1.item.JOBNO,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(row1.item.allModuleId),
            "fk_booking_id": Number(row1.item.fk_booking_id),
            "fk_container_id": Number(0),
            "booking_number": row1.item.BookingNo,
            "container_number": ''
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.JOBNO
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e()]
      }
    }, {
      key: "BookingNo",
      fn: function(row2) {
        return [_c('span', {
          style: (row2.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row2.item.SubscriptionId ? _vm.goToSubscriptionPage(row2.item) : ''
            }
          }
        }, [_vm._v(_vm._s(row2.item.BookingNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Billing Type : " + row2.item.is_billingType_status)), _c('br')]), _vm._v(" "), (
          row2.item.is_billingType_status == 'Local' ||
          row2.item.is_billingType_status == 'Both'
        ) ? _c('span', [_vm._v(_vm._s("Local : " +
          (row2.item.billingTypeMain == "Local Billing" ? "Done" : "Pending"))), _c('br')]) : _vm._e(), _vm._v(" "), (
          row2.item.is_billingType_status == 'Overseas' ||
          row2.item.is_billingType_status == 'Both'
        ) ? _c('span', [_vm._v(_vm._s("Overseas : " +
          (row2.item.is_manifestation_status == "Yes" ? "Done" : "Pending"))), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.blType) ? _c('span', [_vm._v(_vm._s("BL Type : " + row2.item.blType)), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.frghtTermsHbl) ? _c('span', [_vm._v(_vm._s("Freight Terms Hbl : " + row2.item.frghtTermsHbl)), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.frghtTermsMbl) ? _c('span', [_vm._v(_vm._s("Freight Terms Mbl : " + row2.item.frghtTermsMbl)), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.frghtTermsLiner) ? _c('span', [_vm._v(_vm._s("Freight Terms Liner : " + row2.item.frghtTermsLiner)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "JOBNO",
      fn: function(row3) {
        return [_c('tr', {
          class: {
            blink: _vm.isBlinking(row3.item)
          },
          on: {
            "click": function($event) {
              _vm.goPage(row3.item)
            }
          }
        }, [_c('td', [_c('span', [_vm._v(_vm._s("JOBNO : " + row3.item.JOBNO))]), _c('br')])]), _vm._v(" "), _c('span', [_vm._v(_vm._s("JOBDate : " + row3.item.JOBDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("RaisedBy : " + row3.item.RaisedBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("MBLNO : " + row3.item.MBLNO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("HBLNO : " + row3.item.HBLNO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Tot Cont : " + row3.item.ContainerCount))]), _c('br'), _vm._v(" "), (row3.item.freightContainers) ? _c('div', {
          staticClass: "text-left"
        }, [(row3.item.freightContainers) ? _c('div', _vm._l((row3.item.freightContainers.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                    ")])], 1), _vm._v(" "), (row3.item.allModuleId && item1) ? _c('ContaierWebLogSummary', {
            attrs: {
              "PMC_title": 'Container Event Summary Job No - ' + row3.item.JOBNO,
              "PMC_JOBID": row3.item.allModuleId,
              "PMC_JOBNO": row3.item.JOBNO,
              "PMC_CONTNO": item1,
              "PMC_JOBDATE": '',
              "PMC_JOBTYPE": '',
              "PMC_AgentType": '',
              "PMC_Client": '',
              "PMC_Sline": ''
            }
          }) : _vm._e()], 1)
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.clientName))])]
      }
    }, {
      key: "shippingLine",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.shippingLine))])]
      }
    }, {
      key: "POR",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s("POR : " + row6.item.POR))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POL : " + row6.item.POL))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POD : " + row6.item.POD))])]
      }
    }, {
      key: "vgmcut_off_date_est",
      fn: function(row10) {
        return [_c('span', {
          class: row10.item.VGM_submissionDate_actual == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row10.item)
            }
          }
        }, [_vm._v(_vm._s(row10.item.VGM_submissionDate_actual))]), _vm._v("/\n            "), _c('span', {
          class: row10.item.vgmcut_off_date_est == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row10.item)
            }
          }
        }, [_vm._v(_vm._s(row10.item.vgmcut_off_date_est))])]
      }
    }, {
      key: "si_cutoff_est",
      fn: function(row11) {
        return [_c('span', {
          class: row11.item.SI_Submissiondate_actual == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row11.item)
            }
          }
        }, [_vm._v(_vm._s(row11.item.SI_Submissiondate_actual))]), _vm._v("/\n            "), _c('span', {
          class: row11.item.si_cutoff_est == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row11.item)
            }
          }
        }, [_vm._v(_vm._s(row11.item.si_cutoff_est))])]
      }
    }, {
      key: "tr_cutoff_date_est",
      fn: function(row12) {
        return [_c('span', {
          class: row12.item.tr_Submissiondate_actual == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row12.item)
            }
          }
        }, [_vm._v(_vm._s(row12.item.tr_Submissiondate_actual))]), _vm._v("/\n            "), _c('span', {
          class: row12.item.tr_cutoff_date_est == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goVGMPage(row12.item)
            }
          }
        }, [_vm._v(_vm._s(row12.item.tr_cutoff_date_est))])]
      }
    }, {
      key: "handoverDate_actual",
      fn: function(row12) {
        return [_c('span', {
          class: row12.item.handoverDate_actual == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s(row12.item.handoverDate_actual))]), _vm._v("/\n            "), _c('span', {
          class: row12.item.handover_cutoff_date_est == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s(row12.item.handover_cutoff_date_est))])]
      }
    }, {
      key: "oe_payment_status",
      fn: function(row13) {
        return [_c('span', [_vm._v(_vm._s("Payment Status : " + row13.item.oe_payment_status))]), _c('br'), _vm._v(" "), _c('span', {
          class: row13.item.oe_payment_date_first == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Payment First Date : " +
          row13.item.oe_payment_date_first))])]
      }
    }, {
      key: "SOB",
      fn: function(row14) {
        return [_c('span', {
          class: row14.item.SOB == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("P44 : " + row14.item.SOB))]), _c('br'), _vm._v(" "), _c('span', {
          class: row14.item.SysSOB == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Sys : " + row14.item.SysSOB))])]
      }
    }, {
      key: "SysETA_actual",
      fn: function(row15) {
        return [_c('span', {
          class: row15.item.ETA_estimated == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("OF ETA Estimated : " + row15.item.ETA_estimated))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.ETA_actual == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("OF ETA Actual : " + row15.item.ETA_actual))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.SysETA_estimated == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Sys ETA Estimated : " + row15.item.SysETA_estimated))]), _c('br'), _vm._v(" "), _c('span', {
          class: row15.item.SysETA_actual == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Sys ETA Actual : " + row15.item.SysETA_actual))])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d7d65d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pendency/assignmentPendency.vue
// module id = 2727
// module chunks = 0